<template lang="pug">
    v-container(grid-list-md v-if="logTransaction") 
        v-layout(wrap)
            v-flex(lg3 md3 xs12 class="subtitle-text primary--text" ) No. Virtual Account
            v-flex(lg9 md9 xs12 class="subtitle-text primary--text" ) {{ virtualAccountValue }}
            v-flex(lg3 md3 xs12 class="subtitle-text primary--text" ) Periode
            v-flex(lg9 md9 xs12 class="subtitle-text primary--text" ) {{ periode }}
        v-layout(wrap)
            v-flex(lg12 md12 xs12 v-if="logTransaction.details && logTransaction.details.length > 0" )
                v-data-table(
                    hide-default-footer
                    :headers="headers"
                    :items="logTransaction.details"
                )
                    template(v-slot:item.transactionDateTime="{item}")
                        div {{item.transactionDateTime | datetimeformat}}
                    template(v-slot:item.settlementDate="{item}")
                        div {{item.settlementDate | dateformat}}
                    template(v-slot:item.amount="{item}")
                        div {{item.amount | decimalformat}}
</template>
<script>
export default {
    name: "FLogVirtualAccountContent",
    props: ["log", "va", "periode"],
    data() {
        return {
            logTransaction: {},
            virtualAccount: {},
            headers: [
                {text: 'TANGGAL', value: 'transactionDateTime', sortable: false, width: "100px", align:"center", class: "primary--text"},
                {text: 'NO. TRX BANK', value: 'transactionId', sortable: false, width: "100px", align:"center", class: "primary--text"},
                {text: 'TANGGAL BANK', value: 'settlementDate', sortable: false, width: "100px", align:"center", class: "primary--text"},
                {text: 'NO. REFERENSI', value: 'referenceId', sortable: false, width: "100px", align:"center", class: "primary--text"},
                {text: 'URAIAN', value: 'note', sortable: false, class: "primary--text"},
                {text: 'TIPE', align: "center", value: 'dbCr', sortable: false, width: "80px", class: "primary--text"},
                {text: 'NOMINAL', align: "right", value: 'amount', sortable: false, width: "120px", class: "primary--text"},
            ],
        }
    },
    watch: {
        log(val){
            this.logTransaction = val ? val : null;
        },
        va(val){
            this.virtualAccount = val ? val : {
                virtualAccountNumber: "",
                virtualAccountName: ""
            };
        }
    },
    computed: {
        virtualAccountValue() {
            if (this.virtualAccount) {
                return this.virtualAccount.virtualAccountNumber + " - " + this.virtualAccount.virtualAccountName
            }
        }
    },
    mounted() {
        this.logTransaction = this.log ? this.log : null;
        this.virtualAccount = this.va ? this.va : {
                virtualAccountNumber: "",
                virtualAccountName: ""
            };
    },

};
</script>